const companyLogo: string = process.env.REACT_APP_DELIEVERY_NOTE_LOGO || './';
const companyName: string = process.env.REACT_APP_DELIEVERY_NOTE_NAME || '-';
const companyStreet: string = process.env.REACT_APP_DELIEVERY_NOTE_STREET || '-';
const companyPostalCode: string = process.env.REACT_APP_DELIEVERY_NOTE_POSTALCODE || '-';
const companyTown: string = process.env.REACT_APP_DELIEVERY_NOTE_TOWN || '-';
const showItemDescription: boolean = process.env.REACT_APP_DELIEVERY_NOTE_DESCRIPTION === 'true';

const calculatePageBreak = (products: any[]): string => {
    const length = products.length || 0;
    if (length <= 18) return 'auto'; // No page break needed if there are 18 or fewer products
    if (length > 18 && length <= 21) return 'always'; // Page break needed if there are more than 18 products
    if (length > 21) return 'auto'; // Page break needed if there are more than 21 products
    return 'auto';
};

const LieferSchein = ({
    street,
    housenumber,
    postalcode,
    town,
    manager,
    object_number,
    object_id,
    created,
    order_id,
    comment,
    object_note,
    company,
    products,
}: {
    street?: string;
    housenumber?: string;
    postalcode?: string;
    town?: string;
    manager?: string;
    object_id?: string;
    created?: string;
    order_id?: string;
    object_number?: number;
    comment?: string;
    object_note?: string;
    company?: string;
    products?: any;
}) => {
    const formatText = (text: string | undefined, defaultChar: string = ''): string => {
        if (!text) return defaultChar; // Return a placeholder if the comment is empty
        return `${text}`
            .trim() // Remove leading and trailing spaces
            .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
            .replace(/\n/g, '<br />') // Replace newlines with <br />
            .replace(/\t/g, ' '); // Replace tabs with a single space
    };

    const formatDescription = (description: string | undefined): string => {
        if (!description) return ''; // Return empty if no description
        return description
            .trim() // Remove leading and trailing spaces
            .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
            .replace(/\n/g, '') // Replace newlines
            .replace(/\t/g, ' '); // Replace tabs with a single space
    };

    return (
        <div className="container">
            <div className="header">
                <div className="customer-address">
                    <strong>Lieferanschrift</strong>
                    <br />
                    {formatText(company)}
                    <br />
                    {formatText(street)} {formatText(housenumber)} <br />
                    {formatText(postalcode)} {formatText(town)}
                    <div className="project-info">
                        <strong>Objektnummer:</strong> {formatText(`${object_number}`)}
                        <br />
                        <strong>Bestelldatum:</strong> {formatText(created)}
                    </div>
                </div>

                <div className="company-info">
                    <img
                        src={`/${companyLogo}`}
                        alt="Firmenlogo"
                        className="logo"
                    />
                    <br />
                    {companyName}
                    <br />
                    {companyStreet}
                    <br />
                    {companyPostalCode} {companyTown}
                </div>
            </div>

            <div className="document-title">Lieferschein {formatText(order_id)}-2</div>

            <table
                style={{
                    pageBreakInside: 'auto',
                    marginBottom: '2rem',
                    width: '100%',
                    borderCollapse: 'collapse',
                }}
            >
                <thead style={{ display: 'table-header-group' }}>
                    <tr>
                        <th>Pos.</th>
                        <th>Art. Nr.</th>
                        <th>Beschreibung</th>
                        <th>Menge</th>
                    </tr>
                </thead>
                <tbody>
                    {(products || [])
                        .sort((a: any, b: any) => a.article_number - b.article_number)
                        .map((product: any, index: number) => (
                            <tr
                                key={index}
                                style={{
                                    pageBreakInside: 'avoid',
                                    pageBreakAfter: 'auto',
                                }}
                            >
                                <td>{index + 1}</td>
                                <td>{product.article_number}</td>
                                <td>
                                    {product.name}
                                    {showItemDescription ? (
                                        <span> - {formatDescription(product.description)}</span>
                                    ) : null}
                                </td>
                                <td>
                                    {product.units_after}{' '}
                                    {product.unit_name ? `${product.unit_name}` : ''}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
            {/* Signature Section */}
            <div
                style={{
                    marginTop: '5rem',
                    textAlign: 'left',
                    pageBreakBefore: calculatePageBreak(
                        products
                    ) as React.CSSProperties['pageBreakBefore'], // Apply page break only if necessary
                }}
            >
                <div
                    style={{ borderTop: '1px solid #000', width: '40%', marginBottom: '0.5rem' }}
                ></div>
                <span style={{ fontSize: '0.9rem', fontWeight: 'normal', display: 'block' }}>
                    Datum / Unterschrift Kunde
                </span>
            </div>
        </div>
    );
};

export default LieferSchein;
